import { isValid } from 'date-fns';
import { formatDateForApiRequest } from './formatDateForApiRequest';
/**
 * Converts dates to *string* in ISO format like '2024-06-17T10:43:47.934Z'.
 *
 * Intended to use inside `api`'s.
 *
 * @param range - required
 * @returns
 */
export function convertDateRangeValueToApiFormat(range) {
    return {
        // TODO: to delete later (not working for some reason (-3 hour))
        // dateFrom: range.dateFrom.toISOString(),
        // dateTo: range.dateTo.toISOString(),
        dateFrom: isValid(range.dateFrom) ? formatDateForApiRequest(range.dateFrom) : '',
        dateTo: isValid(range.dateTo) ? formatDateForApiRequest(range.dateTo) : '',
    };
}
